"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InWasm = void 0;
// runtime helper - decode base64
function _dec(s) {
    if (typeof Buffer !== 'undefined')
        return Buffer.from(s, 'base64');
    const bs = atob(s);
    const r = new Uint8Array(bs.length);
    for (let i = 0; i < r.length; ++i)
        r[i] = bs.charCodeAt(i);
    return r;
}
function InWasm(def) {
    if (def.d) {
        // default compiled call: wasm loading during runtime
        // for the sake of small bundling size (<900 bytes) the code is somewhat degenerated
        // see cli.ts for the meaning of the {t, s, d, e} object properties
        const { t, s, d } = def;
        // memorize bytes and module
        let bytes;
        let mod;
        const W = WebAssembly;
        if (t === 2 /* OutputType.BYTES */) {
            if (s)
                return () => bytes || (bytes = _dec(d));
            return () => Promise.resolve(bytes || (bytes = _dec(d)));
        }
        if (t === 1 /* OutputType.MODULE */) {
            if (s)
                return () => mod || (mod = new W.Module(bytes || (bytes = _dec(d))));
            return () => mod
                ? Promise.resolve(mod)
                : W.compile(bytes || (bytes = _dec(d))).then(m => mod = m);
        }
        if (s)
            return (e) => new W.Instance(mod || (mod = new W.Module(bytes || (bytes = _dec(d)))), e);
        return (e) => mod
            ? W.instantiate(mod, e)
            : W.instantiate(bytes || (bytes = _dec(d)), e).then(r => (mod = r.module) && r.instance);
    }
    // invalid call: uncompiled normal run throws
    if (typeof _wasmCtx === 'undefined')
        throw new Error('must run "inwasm"');
    _wasmCtx.add(def);
}
exports.InWasm = InWasm;
//# sourceMappingURL=index.js.map